export default __webpack_public_path__ + "static/media/loc2.655cd5a6.svg";